eval("define(\'orouser/js/constants/capability-categories\',{\n    GENERAL: \'system_capabilities\',\n    COMMON: \'all\'\n});\n\n//# sourceURL=/orouser/js/constants/capability-categories.js");

